import { useMemo } from 'react'

import { StructureDto, StructureObjectDto } from '@/endpoints/models'
import { TableMode } from '@/enums'
import { RootState } from '@/store'
import { AppDispatch } from '@/store/utils'

import { getStructureTypeActions } from './getStructureTypeActions'

export type InitDataParams = {
	abortController?: AbortController
	editMode?: boolean
	envId?: number
	force?: boolean
	mode?: TableMode
	nodeId: number
	/** Load draft JSON without treating the tab as edit mode (e.g. AI structure sync). */
	refreshWorkingCopy?: boolean
	version?: number
}

export type SaveDataOptions = {
	isUpperCase?: boolean
	skipCodeGeneration?: boolean
}

export type StructureTypeActions = {
	initData: (params: InitDataParams) => (dispatch: AppDispatch) => Promise<void>
	saveData: (
		node: StructureDto,
		options?: SaveDataOptions,
	) => (dispatch: AppDispatch, getState: () => RootState) => Promise<any>
	updateData: (
		node: StructureDto,
		update: Record<string, any>,
		mode?: TableMode,
	) => unknown
}

/** Get redux actions for specific structure type */
export const useStructureTypeActions = (type: StructureObjectDto.TypeEnum) => {
	const structureTypeActions = useMemo<StructureTypeActions>(
		() => getStructureTypeActions(type),
		[type],
	)

	return structureTypeActions
}
